import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaClock,
  FaUser,
  FaCommentDots,
  FaPaperPlane,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaCheckCircle,
  FaHeadset,
  FaBus,
} from "react-icons/fa";
import contactHeroImage from "../Assets/images/onebusbranding.png";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Connect to backend API later
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
  };

  return (
    <div className="staffline-contact-page">

      {/* ===== HERO HEADER WITH BACKGROUND IMAGE ===== */}
      <section
        className="staffline-contact-hero"
        style={{ backgroundImage: `url(${contactHeroImage})` }}
      >
        <div className="staffline-contact-hero-overlay"></div>
        <div className="container staffline-contact-hero-content">
          <span className="staffline-contact-hero-tag">
            <FaHeadset /> We're Here to Help
          </span>
          <h1 className="staffline-contact-hero-title">
            Get in Touch with <span>StaffLine</span>
          </h1>
          <p className="staffline-contact-hero-subtitle">
            Have a question about routes, subscriptions, corporate plans, or
            anything else? Our team is ready to assist you every step of the way.
          </p>
        </div>
      </section>

      {/* ===== CONTACT INFO CARDS ===== */}
      <section className="staffline-contact-info-section">
        <div className="container">
          <div className="staffline-contact-info-grid">

            {/* Phone Card */}
            <div className="staffline-contact-info-card">
              <div className="staffline-contact-info-icon">
                <FaPhoneAlt />
              </div>
              <h3>Call Us</h3>
              <p>Mon – Fri, 8:00 AM – 6:00 PM</p>
              <a href="tel:+233531030191" className="staffline-contact-info-link">
                +233 53 103 0191
              </a>
              <a href="tel:+233531030191" className="staffline-contact-info-link">
                +233 53 103 0191
              </a>
            </div>

            {/* Email Card */}
            <div className="staffline-contact-info-card">
              <div className="staffline-contact-info-icon">
                <FaEnvelope />
              </div>
              <h3>Email Us</h3>
              <p>We reply within 24 hours</p>
              <a
                href="mailto:stafflinetransportgh@gmail.com"
                className="staffline-contact-info-link"
              >
                stafflinetransportgh@gmail.com
              </a>
              <a
                href="mailto:stafflinetransportgh@gmail.com"
                className="staffline-contact-info-link"
              >
                stafflinetransportgh@gmail.com
              </a>
            </div>

            {/* Location Card */}
            <div className="staffline-contact-info-card">
              <div className="staffline-contact-info-icon">
                <FaMapMarkerAlt />
              </div>
              <h3>Visit Us</h3>
              <p>Our head office</p>
              <span className="staffline-contact-info-text">
                StaffLine Transport HQ
                <br />
                Accra, Greater Accra Region
                <br />
                Ghana
              </span>
            </div>

            {/* WhatsApp Card */}
            <div className="staffline-contact-info-card staffline-contact-info-card-accent">
              <div className="staffline-contact-info-icon">
                <FaWhatsapp />
              </div>
              <h3>WhatsApp Us</h3>
              <p>Fastest way to reach us</p>
              <a
                href="https://wa.me/233531030191"
                target="_blank"
                rel="noopener noreferrer"
                className="staffline-contact-info-btn"
              >
                Chat on WhatsApp
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* ===== MAIN CONTACT SECTION (Form + Side Info) ===== */}
      <section className="staffline-contact-main-section">
        <div className="container">
          <div className="staffline-contact-main-grid">

            {/* LEFT: Contact Form */}
            <div className="staffline-contact-form-wrapper">
              <span className="staffline-contact-section-tag">
                <FaPaperPlane /> Send a Message
              </span>
              <h2 className="staffline-contact-section-title">
                Drop Us a Line
              </h2>
              <p className="staffline-contact-section-desc">
                Fill out the form below and our team will get back to you within
                24 hours. For urgent matters, please call or WhatsApp us directly.
              </p>

              {submitted && (
                <div className="staffline-contact-success">
                  <FaCheckCircle />
                  <span>
                    Thank you! Your message has been sent successfully. We'll be
                    in touch soon.
                  </span>
                </div>
              )}

              <form className="staffline-contact-form" onSubmit={handleSubmit}>
                <div className="staffline-contact-form-row">
                  <div className="staffline-contact-form-group">
                    <label htmlFor="name">
                      <FaUser /> Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="John Doe"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="staffline-contact-form-group">
                    <label htmlFor="email">
                      <FaEnvelope /> Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="john@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="staffline-contact-form-row">
                  <div className="staffline-contact-form-group">
                    <label htmlFor="phone">
                      <FaPhoneAlt /> Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="+233 54 000 0000"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="staffline-contact-form-group">
                    <label htmlFor="subject">
                      <FaCommentDots /> Subject
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="subscription">Subscription Enquiry</option>
                      <option value="routes">Route Information</option>
                      <option value="corporate">Corporate Plan</option>
                      <option value="support">Customer Support</option>
                      <option value="driver">Drive with Us</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="staffline-contact-form-group">
                  <label htmlFor="message">
                    <FaCommentDots /> Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    placeholder="Tell us how we can help you..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="staffline-contact-submit">
                  <FaPaperPlane /> Send Message
                </button>
              </form>
            </div>

            {/* RIGHT: Side Info */}
            <aside className="staffline-contact-side">

              {/* Office Hours */}
              <div className="staffline-contact-side-card">
                <div className="staffline-contact-side-icon">
                  <FaClock />
                </div>
                <h3>Office Hours</h3>
                <ul className="staffline-contact-hours">
                  <li>
                    <span>Monday – Friday</span>
                    <span>8:00 AM – 6:00 PM</span>
                  </li>
                  <li>
                    <span>Saturday</span>
                    <span>9:00 AM – 2:00 PM</span>
                  </li>
                  <li>
                    <span>Sunday</span>
                    <span>Closed</span>
                  </li>
                </ul>
                <p className="staffline-contact-side-note">
                  <FaBus /> Our shuttle service runs Monday – Friday only.
                </p>
              </div>

              {/* Social Media */}
              <div className="staffline-contact-side-card staffline-contact-side-card-navy">
                <h3>Follow Us</h3>
                <p>Stay connected on social media</p>
                <div className="staffline-contact-socials">
                  <a
                    href="https://www.facebook.com/StaffLineTransport"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                 
                  <a
                    href="https://www.linkedin.com/company/staffline-transport-ltd/home/?viewAsMember=true"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a
                    href="https://wa.me/233531030191"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>

            </aside>
          </div>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <section className="staffline-contact-cta">
        <div className="container staffline-contact-cta-content">
          <h2>Ready to Ride with StaffLine?</h2>
          <p>
            Join hundreds of workers enjoying reliable, comfortable, and
            stress-free daily commutes.
          </p>
          <a href="/subscription" className="staffline-contact-cta-btn">
            Subscribe Now
          </a>
        </div>
      </section>

    </div>
  );
};

export default Contact;